/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface IsoMode {
}

export enum IsoMode_Enum {
  ISO_MODE_AUTO = 0,
  ISO_MODE_100 = 100,
  ISO_MODE_200 = 200,
  ISO_MODE_400 = 400,
  ISO_MODE_800 = 800,
  ISO_MODE_1600 = 1600,
  ISO_MODE_3200 = 3200,
  ISO_MODE_6400 = 6400,
  ISO_MODE_9600 = 9600,
  ISO_MODE_12800 = 12800,
  ISO_MODE_16000 = 16000,
  UNRECOGNIZED = -1,
}

export function isoMode_EnumFromJSON(object: any): IsoMode_Enum {
  switch (object) {
    case 0:
    case "ISO_MODE_AUTO":
      return IsoMode_Enum.ISO_MODE_AUTO;
    case 100:
    case "ISO_MODE_100":
      return IsoMode_Enum.ISO_MODE_100;
    case 200:
    case "ISO_MODE_200":
      return IsoMode_Enum.ISO_MODE_200;
    case 400:
    case "ISO_MODE_400":
      return IsoMode_Enum.ISO_MODE_400;
    case 800:
    case "ISO_MODE_800":
      return IsoMode_Enum.ISO_MODE_800;
    case 1600:
    case "ISO_MODE_1600":
      return IsoMode_Enum.ISO_MODE_1600;
    case 3200:
    case "ISO_MODE_3200":
      return IsoMode_Enum.ISO_MODE_3200;
    case 6400:
    case "ISO_MODE_6400":
      return IsoMode_Enum.ISO_MODE_6400;
    case 9600:
    case "ISO_MODE_9600":
      return IsoMode_Enum.ISO_MODE_9600;
    case 12800:
    case "ISO_MODE_12800":
      return IsoMode_Enum.ISO_MODE_12800;
    case 16000:
    case "ISO_MODE_16000":
      return IsoMode_Enum.ISO_MODE_16000;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IsoMode_Enum.UNRECOGNIZED;
  }
}

export function isoMode_EnumToJSON(object: IsoMode_Enum): string {
  switch (object) {
    case IsoMode_Enum.ISO_MODE_AUTO:
      return "ISO_MODE_AUTO";
    case IsoMode_Enum.ISO_MODE_100:
      return "ISO_MODE_100";
    case IsoMode_Enum.ISO_MODE_200:
      return "ISO_MODE_200";
    case IsoMode_Enum.ISO_MODE_400:
      return "ISO_MODE_400";
    case IsoMode_Enum.ISO_MODE_800:
      return "ISO_MODE_800";
    case IsoMode_Enum.ISO_MODE_1600:
      return "ISO_MODE_1600";
    case IsoMode_Enum.ISO_MODE_3200:
      return "ISO_MODE_3200";
    case IsoMode_Enum.ISO_MODE_6400:
      return "ISO_MODE_6400";
    case IsoMode_Enum.ISO_MODE_9600:
      return "ISO_MODE_9600";
    case IsoMode_Enum.ISO_MODE_12800:
      return "ISO_MODE_12800";
    case IsoMode_Enum.ISO_MODE_16000:
      return "ISO_MODE_16000";
    case IsoMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseIsoMode(): IsoMode {
  return {};
}

export const IsoMode = {
  encode(_: IsoMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IsoMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIsoMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): IsoMode {
    return {};
  },

  toJSON(_: IsoMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<IsoMode>, I>>(base?: I): IsoMode {
    return IsoMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IsoMode>, I>>(_: I): IsoMode {
    const message = createBaseIsoMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
